import axios from '../../../axios';
import EmailConfigPayload from '../types/EmailConfigPayload';

const url = 'emailingapp/api/imap/configuration';

export const postSMTPConfig = (payload: EmailConfigPayload) => axios.post(`${url}/add`, payload);

export const getSMTPConfig = () => axios.get(`${url}/fetch`);

export const updateImapConfig = (payload: EmailConfigPayload) =>
  axios.put(`${url}/update`, payload);

export const deleteSMTPConfig = (configId: string) => axios.delete(`${url}/delete/${configId}`);
